import { Brand } from "@jog/types"
import { asImageSrc, isFilled } from "@prismicio/helpers"
import { ImageField, KeyTextField, type RichTextField, Slice, SliceZone } from "@prismicio/types"

import { typedBoolean } from "../helper"

export type PrismicBrandsJson = Brand[]
export type PrebuildBrandsFetch = () => Promise<PrismicBrandsJson>

export const transBrands = ({
    body,
}: {
    body: SliceZone<Slice<"brand", { brand_id: KeyTextField; brand_logo: ImageField; brand_info: RichTextField }, {}>>
}) =>
    [...(body || [])]
        .map((slice) => {
            if (!isFilled.image(slice.primary.brand_logo)) return
            if (!slice.primary.brand_id) return
            return {
                brandId: slice.primary.brand_id,
                alt: slice.primary.brand_logo.alt,
                url: asImageSrc(slice.primary.brand_logo),
                width: slice.primary.brand_logo.dimensions?.width || 0,
                height: slice.primary.brand_logo.dimensions?.height || 0,
                brandInfo: slice.primary.brand_info,
            }
        })
        .filter(typedBoolean)
